import { render, staticRenderFns } from "./extraConfig.vue?vue&type=template&id=dc5a853e"
import script from "./extraConfig.vue?vue&type=script&lang=js"
export * from "./extraConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports